import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class BalanceTextCurrency extends BitmapBaseValue{
  constructor(data) {
    super(data)

    this.winModel = game.models.WinModel.get()
    this.spinModel = game.models.SpinModel.get()

    this.balance = { value: 0 }

    signal.once('INIT:REGULAR', this.start.bind(this))
    signal.once('INIT:FREESPINS', this.startFS.bind(this))
    signal.on('STATE:IN:FS-START', this.startFS.bind(this))
    signal.on('STATE:OUT:FS-END', this.start.bind(this))
    signal.on('BALANCE:UPDATE', this.updateTweenBalance.bind(this))
    signal.on('BALANCE:SERVER:UPDATE', this.update.bind(this))
    signal.on('STATE:OUT:INIT', this.update.bind(this))
  }

  start() {
    this.update()
    signal.on('ACTION:REQUEST-SPIN', this.spin.bind(this))
    signal.on('WIN-COLLECT', this.win.bind(this))
    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.cascadeWin.bind(this))
    signal.on('STATE:OUT:RESPIN', this.joinRespin.bind(this))
  }

  startFS() {
    this.update()
    signal.off('ACTION:REQUEST-SPIN', this.spin.bind(this))
    signal.on('WIN-COLLECT', this.win.bind(this))
    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.cascadeWin.bind(this))
    signal.on('STATE:OUT:RESPIN', this.joinRespin.bind(this))
  }

  joinRespin() {
    !this.winModel.winLines.length && this.roll(game.models.BalanceModel.get(), time.respin)
  }

  update() {
    this.balance.value = game.models.BalanceModel.get()
    this.onUpdate()
  }

  updateTweenBalance(){
    this.roll(game.models.BalanceModel.get(), time.spin)
  }

  spin() {
    const current = game.models.SpinModel.get().action
    if(game.models.ModeModel.buyFeature) {
      const multiplier = game.models.SpinModel.get().buy[0]
      this.roll(game.models.BalanceModel.get() - (game.models.BetModel.getValue() * multiplier), time.spin)
    }
    else {
      if(current === 'freebet' || current === 'respin' || current !== 'spin') {
        return
      }
      this.roll(game.models.BalanceModel.get() - game.models.BetModel.getValue(), time.spin)
    }
  }

  cascadeWin({ type, amount }){
    const value = this.balance.value + amount

    this.roll(value, time[type])
  }

  win({ type, amount }) {
    const value = !this.spinModel.respinTotalWin ? Math.min(this.balance.value + amount, game.models.BalanceModel.get()) : game.models.BalanceModel.get()
    this.roll(value, time[type])
  }

  roll(value, time) {
    const balanceTween =  gsap.to(this.balance, time, {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        balanceTween.kill()
      },
    })

  }

  onUpdate() {
    super.center()
    super.update(FormatService.currency(this.balance.value))
  }
}
